/**
 * returns true if at least 1 student has a medium or high dyslexia risk
 * @param {*} report dyslexia report data
 * @param {*} cutoffs
 * @returns {boolean}
 */
export default function isAnyStudentAtRisk(report, cutoffs) {
  return Array.from(report.scores.values()).some(row => row.highestRawScore >= cutoffs.MEDIUM_RISK);
}